// src/data/exercises/L5_02.js

const accountOptions = [
  '現金', '仕入', '備品', '立替金', '未払金'];

export const L5_02 = {
  title: '簿記　3級（第214-2回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
       parts: [
    { "type": "ruby", "text": "従業員個人", "ruby": "じゅうぎょういんこじん" },
    { "type": "text", "value": "が" },
    { "type": "ruby", "text": "負担", "ruby": "ふたん" },
    { "type": "text", "value": "すべき" },
    { "type": "ruby", "text": "物品", "ruby": "ぶっぴん" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "購入代金", "ruby": "こうにゅうだいきん" },
    { "type": "text", "value": "￥30,000を" },
    { "type": "ruby", "text": "立", "ruby": "た" },
    { "type": "text", "value": "て" },
    { "type": "ruby", "text": "替", "ruby": "か" },
    { "type": "text", "value": "えて、" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '立替金', debitAmount: 30000, creditAccount: '現金', creditAmount: 30000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「現金で支払った」なので、\n' },
          { type: 'styled', value: '①現金が減少（マイナス）貸方（右・Ｃｒ）です。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「立て替えて」＝かわりに払ったお金\n' },
          { type: 'styled', value: '②立替金が増加（プラス）借方（左・Ｄｒ）です。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
「現金で支払った」なので、
①現金が減少（マイナス）します。

「立て替えて」＝かわりに払ったお金
②立替金が増加（プラス）します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '「現金で支払った」なので、\n' },
          { type: 'styled', value: '①現金が減少（マイナス）貸方（右・Ｃｒ）です。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「立て替えて」＝かわりに払ったお金\n' },
          { type: 'styled', value: '②立替金が増加（プラス）借方（左・Ｄｒ）です。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};